import type { Message } from '../types/messages.ts';

export function isDebugMessage(message: Message): boolean {
  if (message.type === 'outgoing_message' && message.body.type === 'pause') {
    return true;
  }

  if (message.type === 'tool_call' || message.type === 'system_message') {
    return true;
  }

  return false;
}
